import { render, staticRenderFns } from "./StepSsnDetails.vue?vue&type=template&id=09aa8b85&"
import script from "./StepSsnDetails.vue?vue&type=script&lang=js&"
export * from "./StepSsnDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports